import styled from 'styled-components'

export const Wrapper = styled.div`
  max-width: 20%;
`

export const ProfileMenu = styled.nav`
  margin-right: 4px;
`

export const ProfileBox = styled.div`
  background: #ffffff;
  padding: 16px;
  border: 1px solid #e5e5e5;
  border-radius: 4px;
  font-size: 14px;
  -webkit-box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.1);
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.1);
`
export const ProfileMenuList = styled.ul`
  hr {
    opacity: 0.3;
    margin-top: -4px;
    margin-bottom: 10px;
  }
`

export const ProfileMenuItem = styled.li`
  display: block;
  margin-bottom: 16px;

  &:last-child {
    margin-bottom: 0px;
  }

  a {
    transition: all 400ms;

    &:hover,
    &._is-active {
      color: red;
      text-decoration: underline;
    }

    &._is-active {
      font-weight: bold;
      color: #d22630;
    }
  }
`
